import * as React from 'react';

export const CrownFilledIcon = () => {
	return (
		<svg width='21' height='20' viewBox='0 0 21 20' xmlns='http://www.w3.org/2000/svg'>
			<path d='M3.16602 13.7503L2.16602 5.00033L6.49935 7.25033L10.4993 1.66699L14.4993 7.25033L18.8327 5.00033L17.8327 13.7503C15.9993 12.667 12.7493 12.5003 10.4993 12.5003C8.24935 12.5003 4.99935 12.667 3.16602 13.7503ZM10.4993 14.167C6.58268 14.167 3.41602 14.917 3.41602 15.8337C3.41602 16.7503 6.58268 17.5003 10.4993 17.5003C14.416 17.5003 17.5827 16.7503 17.5827 15.8337C17.5827 14.917 14.416 14.167 10.4993 14.167Z' />
		</svg>
	);
};

export default CrownFilledIcon;
